// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Y8-z"};